import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { AnalyticsEvent } from '../../../../event'
import { AttributeFormatter } from '../../formatters/attribute'
import { PageEvents } from '../../page-events'

const mParticleEvents: any = new PageEvents()

export class InternalPromo extends AnalyticsEvent {

    public attributeFormatter = new AttributeFormatter()
    /**
     * Handle internal promo click event
     */
    public handle(): void {

        /**
         * @var attrs will be different for each
         * events
         *
         * there are events which has will have attributes
         * both from dom element and page meta properties
         */

        const attrs = [
            key.DOMAIN,
            key.BTN_LOC,
            key.INTRNL_PROM_NAME
        ]

        const data = this.attributeFormatter.format(
            attrs,
            {
                ...this.metaProperties,
                ...this.attributeFormatter.intrnlPromoClkAttrformat(this.getProperties())
            }
        )

        mParticleEvents.logEvent(
            PageEvents.mpEventName.InternalPromotionClick,
            PageEvents.mpEventType.Navigation,
            data
        )
    }
}
